module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shipping_list.length) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "Item-Row"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('checkout.shipping')))]), _vm._v("  \n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.localData), function(shipping) {
    return _c('option', {
      domProps: {
        "value": shipping
      }
    }, [_vm._v(_vm._s(shipping.name))])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected_shipping.price),
      expression: "selected_shipping.price"
    }]
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.selected.price, _vm.active_module.currency)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected_shipping.price),
      expression: "selected_shipping.price"
    }],
    staticClass: "Item-Row"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('checkout.total')))]), _vm._v(" "), _c('p', {
    staticClass: "price-bold"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.totalWithShipping, _vm.active_module.currency)))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb17520e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/Shipping.vue
// module id = 270
// module chunks = 1